export default function TITLE_CUSTOMIZE(contname) {
  
  $(() => {
    const $title = $('.hs_entrytitle').unwrap('.detail_title, .titleTxt').removeClass('hs_entrytitle')
    $title.addClass(`p-${contname}__title`).wrapInner('<span/>')
  })
  
}